import React, { FC } from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { BsX } from 'react-icons/bs';

import {
  BANNER_ICONS,
  BANNER_TYPES,
  type BannerFlagKey,
  type BannerFlags,
} from './Banner.types';
import {
  BannerContainer,
  IconWrapper,
  TextContent,
  BannerTitle,
  BannerMessage,
  CloseButton,
} from './Banner.styles';
import { useBannerDismissed } from 'hooks/useBannerDismissed';

interface BannerProps {
  flagKey: BannerFlagKey;
}

const Banner: FC<BannerProps> = ({ flagKey }) => {
  const flags = useFlags<BannerFlags>();
  const banner = flags[flagKey];
  const { dismissed, dismiss } = useBannerDismissed(flagKey, banner);

  if (!banner?.message || dismissed) {
    return null;
  }

  const bannerType =
    banner.type && Object.values(BANNER_TYPES).includes(banner.type)
      ? banner.type
      : BANNER_TYPES.INFO;
  const Icon = BANNER_ICONS[bannerType];
  const isDismissible = bannerType === BANNER_TYPES.SUCCESS;

  return (
    <BannerContainer type={bannerType}>
      <IconWrapper type={bannerType}>
        <Icon />
      </IconWrapper>
      <TextContent>
        {banner.title && <BannerTitle>{banner.title}</BannerTitle>}
        <BannerMessage>{banner.message}</BannerMessage>
      </TextContent>
      {isDismissible && (
        <CloseButton type="button" onClick={dismiss} aria-label="Dismiss banner">
          <BsX size={20} />
        </CloseButton>
      )}
    </BannerContainer>
  );
};

export default Banner;
